import React from 'react';
import styled from 'styled-components';
import { ReactComponent as SearchIcon } from '../../../assets/images/search.svg';

const InputSearch = ({ value, onChange, placeholder, className, inputType = 'text' }) => {
  return (
    <InputSearchWrapper className={`flex relative ${className}`}>
      <SearchIcon className="absolute search-icon" height={18} width={18} />
      <input
        className="input"
        value={value}
        onChange={({ target }) => onChange(target.value)}
        placeholder={placeholder}
        type={inputType}
      />
    </InputSearchWrapper>
  );
};

const InputSearchWrapper = styled('div')`
  .search-icon {
    height: 100%;
    margin: 0 8px;
  }

  .input {
    height: 32px;
    font-size: 14px;
    padding-left: 32px;
    border-radius: 12px;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0;
    }
  }
`;

export default InputSearch;
